import ListMui from '@mui/material/List';

import Paper from '@mui/material/Paper';
import Popover from '@mui/material/Popover';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  paper: {
    width: '100%',
    minWidth: 300,
  },

  listbox: {
    listStyle: 'none',
    margin: 0,
    padding: '16px 0',
    maxHeight: '40vh',
    overflow: 'auto',
  },
}));

interface Props {
  anchorEl: HTMLElement | null;
  open: boolean;
  children: React.ReactNode;
  onClose: () => void;
}

function List({ anchorEl, children, onClose, open }: Props) {
  const classes = useStyles();

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      onClose={onClose}
      open={open && Boolean(anchorEl)}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Paper className={classes.paper}>
        <ListMui component="nav">{children}</ListMui>
      </Paper>
    </Popover>
  );
}

export default List;
